import { DataVariants } from "../../../data/DataManager";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema, isEmpty } from "../../../Schema";
import { periodWithoutCheckIn } from "./checkInValidation";

const options = [
  { label: "15 min", value: "15" },
  { label: "30 min", value: "30" },
  { label: "45 min", value: "45" },
  { label: "60 min", value: "60" },
  { label: "120 min", value: "120" },
];

export const checkInStartPeriod: FieldSchema = {
  grid: {
    displayed: true,
    order: 71,
    filter: GridFilterTypes.NUMBER,
    integerOnly: true,
    ignoredForSearch: true,
  },
  name: "checkInStartPeriod",
  data: {
    variant: DataVariants.ENUM,
    options,
    assignedValue: {
      getter: ({ checkInStartPeriod, checkInRequired, isBookable }) =>
        !isBookable || !checkInRequired ? EMPTY_VALUE : isEmpty(checkInStartPeriod) ? "15" : checkInStartPeriod,
      fields: ["isBookable", "checkInRequired"],
    },
  },
  dataTransform: {
    // A non-bookable equipment has no booking behaviour to record, so the stored value
    // is cleared rather than left behind to contradict isBookable.
    toDb: {
      getter: ({ isBookable, checkInRequired, checkInStartPeriod }) =>
        isBookable === false || checkInRequired === false ? EMPTY_VALUE : checkInStartPeriod,
      fields: ["isBookable", "checkInRequired", "checkInStartPeriod"],
    },
  },
  display: {
    displayed: true,
  },
  validation: {
    required: {
      getter: ({ isBookable, checkInRequired }) => isBookable === true && checkInRequired === true,
      fields: ["isBookable", "checkInRequired"],
    },
    custom: periodWithoutCheckIn("checkInStartPeriod"),
  },
  form: {
    label: "Check in period",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ isBookable, checkInRequired }) => isBookable !== true || checkInRequired !== true,
      fields: ["isBookable", "checkInRequired"],
    },
    helperText: "Possible time period to check in before booking start",
  },
};
